// /* eslint-disable */
export async function makeApiRequest(arzyptoType, path) {
	try {
		let response = null
		if (arzyptoType == 'ARZYPTO_EXCHANGE') {
			response = await fetch(`https://www.arzypto.com/api/history/exchange${path}`)
			// response = await fetch(`http://127.0.0.1:8080/api/history/exchange${path}`)
		} else {
			response = await fetch(`https://www.arzypto.com/api/history/${path}`)
		}

		return response.json()
	} catch (error) {
		throw new Error(`Arzypto request error: ${error}`)
	}
}

// Generates a symbol ID from a pair of the coins
export function generateSymbol(exchange, fromSymbol, toSymbol) {
	const short = `${fromSymbol}/${toSymbol}`
	return {
		short,
		full: `${exchange}:${short}`
	}
}

// Returns all parts of the symbol
export function parseFullSymbol(fullSymbol) {
	const match = fullSymbol.match(/^(\w+):(\w+)\/(\w+)$/)
	if (!match) {
		return null
	}

	return {
		exchange: match[1],
		fromSymbol: match[2],
		toSymbol: match[3]
	}
}
// /* eslint-disable */
